module.exports = __webpack_public_path__ + "img/water-efficiency.95df78a7.svg";